import * as React from 'react'
import PromotionalCards from '../promotional-cards'
import { OnboardingComponentProps } from '.'
import { Gift, BonusTag, DollarBills } from '../../atoms/icons'
import { CardContent, CardTypes } from '../../molecules/promotional-cards/Card'
import { PromotionalCard } from 'src/components/organisms/workflow-template/types'

const getCardIcon = (iconName: string) => {
  switch (iconName.toUpperCase()) {
    case 'GIFT':
      return <Gift />
    case 'BONUSTAG':
      return <BonusTag />
    case 'DOLLARBILLS':
      return <DollarBills />
    default:
      return null
  }
}

const getPromotionalCard = (jsonCard: PromotionalCard): CardContent => {
  return {
    title: jsonCard.title,
    content: jsonCard.content,
    icon: getCardIcon(jsonCard.icon),
    type: CardTypes.Default,
  }
}

export const PromotionalCardsComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ promotional_cards }) => (
    <PromotionalCards
      cards={promotional_cards.map(card => getPromotionalCard(card))}
    />
  )
)
